import routes from "@/routes";
import { lazy } from "react";

const OnboardingDistributionAdmin = lazy(
  () => import("@/modules/OnboardingDistributionAdmin")
);

// Super admin only: mounted from `ADMIN_ROUTES` (main.routes.tsx).
const OnboardingAdminRoutes = {
  element: <OnboardingDistributionAdmin />,
  path: routes.ONBOARDING_DISTRIBUTION_ADMIN.INDEX,
};

export default OnboardingAdminRoutes;
